import {NgModule} from '@angular/core';
import {CommonModule} from './common/common.module';
import {UserModule} from './user/user.module';
import {ProfileModule} from './profile/profile.module';
import {CountryModule} from './info/country/country.module';
import {PracticeSpecialtyModule} from './info/practicespecialty/practice-specialty.module';
import {LanguageModule} from './info/language/language.module';
import {EducationModule} from './education/education.module';
import {WorkModule} from './work/work.module';
import {LicensesCertificationsModule} from './licenses-certifications/licenses-certifications.module';
import {ProfessionalLiabilityModule} from './liability/professional-liability.module';
import {ProfessionalReferenceModule} from './reference/professional-reference.module';
import {PlaceInfoModule} from './info/place/place-info.module';
import {ReleaseAuthorizationModule} from './release/release-authorization.module';
import {ClientInfoModule} from './info/client/client-info.module';
import {ProfileCompletionModule} from './completion/profile-completion.module';
import {NpiModule} from './npi/npi.module';
import {FileModule} from '../../components/files/service/file.module';
import {AdminReportsModule} from './admin-reports/admin-reports.module';

/**
 * Created by Rodrigo Quesada on 09/12/16.
 */
@NgModule({
    imports: [
        CommonModule,
        ClientInfoModule,
        CountryModule,
        LanguageModule,
        PlaceInfoModule,
        PracticeSpecialtyModule,
        UserModule,
        ProfileCompletionModule,
        ProfileModule,
        EducationModule,
        WorkModule,
        LicensesCertificationsModule,
        ProfessionalLiabilityModule,
        ProfessionalReferenceModule,
        ReleaseAuthorizationModule,
        NpiModule,
        FileModule,
        AdminReportsModule
    ]
})
export class ModelModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/model.module.ts